import Storage from '../Storage.js';

Storage.setConfig("users", {
  section: "main",
  config: {
    method: "users/",
    title: "Пользователи",
    objectName: "Пользователь",
    adminUser: true
  },
  properties: {
    id: {
      default: false,
      type: "text",
      title: "#",
      preset: true,
      width: "20px"
    },
    create_time: {
      default: "",
      type: "text",
      title: "Создан",
      preset: true,
      width: false
    },
    update_time: {
      default: "",
      type: "text",
      title: "Обновлен",
      preset: true,
      width: false
    },
    email: {
      default: "",
      type: "text",
      title: "Email",
      preset: false,
      width: "auto"
    },
    password: {
      default: "",
      type: "password",
      title: "Пароль",
      preset: false,
      width: false
    },
    last_name: {
      default: "",
      type: "text",
      title: "Фамилия",
      preset: false,
      width: "auto"
    },
    first_name: {
      default: "",
      type: "text",
      title: "Имя",
      preset: false,
      width: false
    },
    patronymic: {
      default: "",
      type: "text",
      title: "Отчество",
      preset: false,
      width: false
    },
    position: {
      default: "",
      type: "text",
      title: "Должность",
      preset: false,
      width: "auto"
    },    
    role: {
      default: "",
      type: "select",
      request: "users/roles/",
      title: "Роль",
      preset: false,
      width: "auto"
    },
    user_group: {
      default: {},
      type: "select",
      request: "user_groups/",
      objectPageKey: "user_groups",
      title: "Группа",
      preset: false,
      width: "auto"
    }
  }
});



// WEBPACK FOOTER //
// ./src/config/users.js